import { QueryKeyConfig } from '../api-helper';

export const employeeApiKeyStore = {
  getEmployees: (): QueryKeyConfig => ({
    queryKey: [`GET_EMPLOYEES`],
    route: `/employee`,
  }),
  getEmployeeDetails: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_EMPLOYEES_PROFILE`, id],
    route: `/User/GetUserProfile/${id}`,
  }),
};
